import React from "react";
import { motion } from "framer-motion";

const Heading = ({ title }) => {
  return (
    <div className="relative mb-5 w-fit">
      {/* Heading Text */}
      <h2 className="text-2xl font-semibold tracking-wider uppercase">
        {title}
      </h2>

      {/* Animated Line */}
      <motion.div
        className="absolute w-[50%] h-[4px] bg-black -bottom-2"
        initial={{ scaleX: 0, originX: 0 }} // Start with no width
        animate={{ scaleX: 1 }} // Animate to full width
        transition={{ delay: 0.3, duration: 0.4 }} // Animation delay and duration
      />

      {/* Optional: Vertical Line Animation (if needed) */}
      <motion.div
        className="absolute w-2 h-10 -translate-y-1/2 -left-4 top-1/2 bg-amber-500"
        initial={{ height: 0 }}
        animate={{ height: 40 }}
        transition={{ delay: 0.3, duration: 0.4 }}
      />
    </div>
  );
};

export default Heading;
